var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#21AAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1168 51.9456C32.5998 49.0431 35.3753 46.6304 37.4433 44.7075C39.5113 42.7483 41.2347 40.7166 42.6134 38.6122C43.9921 36.5079 44.6814 34.4399 44.6814 32.4082C44.6814 30.5578 44.246 29.1066 43.3753 28.0544C42.5045 27.0023 41.1621 26.4762 39.3481 26.4762C37.534 26.4762 36.1372 27.093 35.1576 28.3265C34.178 29.5238 33.6701 31.1746 33.6338 33.2789H26.2324C26.3775 28.9252 27.6655 25.6236 30.0964 23.3742C32.5635 21.1247 35.6837 20 39.4569 20C43.593 20 46.7676 21.1066 48.9807 23.3197C51.1939 25.4966 52.3004 28.381 52.3004 31.9728C52.3004 34.8027 51.5385 37.5057 50.0147 40.0816C48.4909 42.6576 46.7494 44.907 44.7902 46.8299C42.8311 48.7166 40.2732 51.0023 37.1168 53.6871H53.1712V60H26.2868V54.3401L29.1168 51.9456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.c35ea5c0bc306aee66e1de990372a7a5.svg";
export { ForwardRef as ReactComponent };